import React from 'react';

const ResultGauge = ({ value, max = 4.0, label, subLabel, size = 200 }) => {
  const percentage = Math.min((value / max) * 100, 100);
  const strokeWidth = 14;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  // Determine color based on value for GPA
  const getGpaColor = (val) => {
    if (val >= 3.7) return 'stroke-emerald-500';
    if (val >= 3.0) return 'stroke-indigo-500';
    if (val >= 2.0) return 'stroke-amber-500';
    return 'stroke-rose-500';
  };

  // Determine color for Percentage
  const getPercentageColor = (val) => {
    if (val >= 80) return 'stroke-emerald-500';
    if (val >= 60) return 'stroke-indigo-500';
    if (val >= 50) return 'stroke-amber-500';
    return 'stroke-rose-500';
  };

  const isPercentage = max > 4.0;
  const colorClass = isPercentage ? getPercentageColor(value) : getGpaColor(value);

  return (
    <div className="flex flex-col items-center justify-center animate-in zoom-in-95 duration-700">
      <div className="relative" style={{ width: size, height: size }}>
        {/* Background Circle */}
        <svg className="w-full h-full transform -rotate-90">
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="transparent"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            className="text-slate-100 dark:text-slate-800"
          />
          {/* Progress Circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="transparent"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            style={{ 
              strokeDashoffset: offset,
              transition: 'stroke-dashoffset 1.5s ease-out, stroke 0.5s ease'
            }}
            strokeLinecap="round"
            className={`${colorClass}`}
          />
        </svg>

        {/* Central Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <span className="text-xs font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em] mb-1">
            {label}
          </span>
          <span className="text-5xl font-black text-slate-900 dark:text-white tracking-tighter">
            {isPercentage ? `${value.toFixed(1)}%` : value.toFixed(2)}
          </span>
          {subLabel && (
            <span className="text-[10px] font-bold text-slate-500 dark:text-slate-400 mt-1 px-3 py-0.5 bg-slate-100 dark:bg-white/5 rounded-full uppercase tracking-widest">
              {subLabel}
            </span>
          )}
        </div>
      </div>
      
      {/* Decorative Glow */}
      <div className={`absolute -z-10 w-32 h-32 blur-[60px] opacity-20 rounded-full transition-colors duration-1000 ${colorClass.replace('stroke', 'bg')}`}></div>
    </div>
  );
};

export default ResultGauge;
